<template>
<div id="app" v-loading.fullscreen.lock="this.$yagi.is_logging">
  <header id="header" class="clearfix">
    <h1 title=""><a href="/"><img src="/static/renew_img/logo.svg" alt=""><p class="pc">ブラウザでつくれる職務経歴書</p><p class="sp">職務経歴書</p></a></h1>
    <div class="btn_wrapper">
      <a v-if="$firebase.isAuthenticated" href="/mypage" class="btn_cta" style="background-color:#E95B10;border-color:#E95B10;" >マイページ<img src="/static/renew_img/icon_home.svg" alt="マイページ"></a>
      <a v-else href="/login" class="btn_cta" style="background-color:#E95B10;border-color:#E95B10;" >ログイン<img src="/static/renew_img/icon_login.svg" alt="ログイン"></a>
    </div>
  </header>
  <router-view></router-view>
  <footer style="background-color:#0F9934;">
    <nav>
      <ol class="clearfix">
        <li>
          <a href="/info" >ヤギッシュの使い方
            <img  src="/static/renew_img/icon_arrow_white.svg"  alt="詳しく見る" class="sp"></a>
        </li>
        <li>
          <a href="/company" >会社概要
            <img  src="/static/renew_img/icon_arrow_white.svg"  alt="詳しく見る" class="sp">
          </a>
        </li>
        <li>
          <router-link id="footer-link-terms"
                        :to="{name: 'termsPage'}">利用規約
          <img  src="/static/renew_img/icon_arrow_white.svg"  alt="詳しく見る" class="sp"></router-link>
        </li>
        <li>
          <router-link id="footer-link-policy"
                        :to="{name: 'policyPage'}">個人情報保護方針
          <img  src="/static/renew_img/icon_arrow_white.svg"  alt="詳しく見る" class="sp"></router-link>
        </li>
        <li>
          <router-link id="footer-link-help"
                        :to="{name: 'helpPage'}">ヘルプ<img src="/static/renew_img/icon_arrow_white.svg"  alt="詳しく見る" class="sp"></router-link>
        </li>
        <li>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSdQWd8nDWMjACUan0rTQH7zQA7kP9tK_YoU5GL2_CpbUpUIiw/viewform" target="_blank">お問い合わせ
          <img  src="/static/renew_img/icon_arrow_white.svg"  alt="詳しく見る" class="sp">
          </a>
        </li>
      </ol>
    </nav>
    <article>
      <ul>
        <li>
          <a data-v-ba1b8cd4="" id="footer-social-share-facebook" href="http://www.facebook.com/share.php?u=https://rirekisho.yagish.jp/" rel="nofollow" target="_blank"><img src="/static/renew_img/icon-facebook.svg" alt="Facebookでシェア"></a>
        </li>
        <li>
          <a data-v-ba1b8cd4="" id="footer-social-share-line" href="http://line.me/R/msg/text/?ブラウザでつくれる履歴書 yagish（ヤギッシュ） https://rirekisho.yagish.jp/" rel="nofollow" target="_blank"><img src="/static/renew_img/icon-line.svg" alt="LINEに送る"></a>
        </li>
        <li>
          <a data-v-ba1b8cd4="" id="footer-social-share-twitter" href="http://twitter.com/intent/tweet?url=https://rirekisho.yagish.jp/&amp;text=ブラウザでつくれる履歴書 yagish（ヤギッシュ）&amp;hashtags=yagish" rel="nofollow" target="_blank"><img src="/static/renew_img/icon-twitter.svg" alt="Twiterでシェア"></a>
        </li>
        <li>
          <a data-v-ba1b8cd4="" id="footer-social-share-hatena" href="http://b.hatena.ne.jp/add?mode=confirm&amp;url=https://rirekisho.yagish.jp/&amp;title=ブラウザでつくれる履歴書 yagish（ヤギッシュ）" rel="nofollow" target="_blank"><img src="/static/renew_img/icon-hatena.svg" alt="はてなブックマーク"></a>
        </li>
      </ul>
      <p>©2022 Yagish Co., Ltd. All rights reserved.</p>
    </article>
  </footer>
  <account-dialog />
  <eprint-dialog />
  <adtop-dialog />
  <medley-dialog />
  <tempdata-dialog />
</div>
</template>

<style lang="scss" src="@/assets/scss/style.scss"></style>
<style lang="css" src="@/assets/css/renew_reset.css"></style>
<style lang="css" src="@/assets/css/renew_stylesheet.css"></style>
<style lang="css" src="@/assets/css/renew_hero.css"></style>
<style lang="css" src="@/assets/css/renew_animation.css"></style>
<style lang="css" src="@/assets/css/renew_tab.css"></style>
<style lang="css" src="@/assets/css/renew_add.css"></style>
<script>
import EprintDialog from '@/components/EprintDialog'
import AdtopDialog from '@/components/AdtopDialog'
import AccountDialog from '@/components/AccountDialog'
import MedleyDialog from '@/components/MedleyDialog'
import TempDataDialog from '@/components/TempDataDialog'
export default {
  components: {
    'eprint-dialog': EprintDialog,
    'account-dialog': AdtopDialog,
    'adtop-dialog': AccountDialog,
    'medley-dialog': MedleyDialog,
    'tempdata-dialog': TempDataDialog
  },
  methods: {
    checkMynabi: function () {
      if (this.$route.query.mynavi === '19xs#rrdfS234') {
        this.$yagi.isFromMynabi = 1
      }
    }
  },
  data: function () {
    return {
		  is_logging: this.$yagi.is_logging,
    }
  },
  computed: {
    logoBaseStyle: function () {
      if (process.env.VUE_APP_MODE === 'production') {
        return {
          fill: '#fff'
        }
      } else if (process.env.VUE_APP_MODE === 'staging') {
        return {
          fill: '#6bff38'
        }
      } else {
        return {
          fill: '#cc38ff'
        }
      }
    },
    logoEyeStyle: function () {
      if (process.env.VUE_APP_MODE === 'production') {
        return {
          fill: '#e91044'
        }
      } else if (process.env.VUE_APP_MODE === 'staging') {
        return {
          fill: '#09bc6c'
        }
      } else {
        return {
          fill: '#fff'
        }
      }
    },
    isTopPage: function () {
      return (this.$route.name === 'top')
    },
    isMynabi: function () {
      this.checkMynabi()
      return (this.$yagi.isFromMynabi === 1)
    },
    isEditingFormat: function () {
      return (this.$route.name === 'formatEditCard')
    },
    needsFullScreen: function () {
      return (this.$route.name === 'formatPreview')
    },
    needsFooter: function () {
      if (this.$route.name === 'formatPreview' || this.$route.name === 'formatEditCard') {
        return false
      }
      return true
    }
  }
}
</script>
